import { Action, Dispatch } from "redux";
import * as http from "../../util/http";
import { Actions } from "./index";

interface PasswordResetVerifyCodeResponse {
    success: boolean;
    passwordResetFlow?: boolean;
}

export function resetPassword(email: string, dispatch: Dispatch<Action>): void {
    dispatch({ type: Actions[Actions.RESET_PASSWORD_START] });
    http.post(http.newRequestDescription("/api/password/reset"), "/api/password/reset", {
        email,
    })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
        .then((responseData: any) => {
            if (responseData.data.ok) {
                dispatch({ type: Actions[Actions.RESET_PASSWORD_SUCCESS] });
            } else {
                dispatch({ type: Actions[Actions.RESET_PASSWORD_FAILED] });
            }
        })
        .catch(err => {
            dispatch({ type: Actions[Actions.RESET_PASSWORD_FAILED] });
        });
}

export function validatePasswordResetToken(
    token: string,
    dispatch: Dispatch<Action>,
): void {
    dispatch({ type: Actions[Actions.RESET_PASSWORD_START] });
    http.post(
        http.newRequestDescription("/api/password/validate-token"),
        "/api/password/validate-token",
        { token },
    )
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
        .then((responseData: any) => {
            if (responseData.data.valid) {
                if (responseData.data.requiresTwoFactor) {
                    dispatch({
                        type: Actions[Actions.RESET_PASSWORD_REQUIRES_2FA],
                        twoFactorData: responseData.data,
                    });
                } else {
                    dispatch({ type: Actions[Actions.RESET_PASSWORD_SUCCESS] });
                }
            } else {
                dispatch({ type: Actions[Actions.RESET_PASSWORD_FAILED] });
            }
        })
        .catch(err => {
            dispatch({ type: Actions[Actions.RESET_PASSWORD_FAILED] });
        });
}

export async function sendPasswordResetVerificationCode(
    method: string,
    dispatch: Dispatch<Action>,
): Promise<void> {
    try {
        await http.post(
            http.newRequestDescription("/api/password/send-verification-code"),
            "/api/password/send-verification-code",
            { method },
        );
    } catch (error) {
        dispatch({ type: Actions[Actions.RESET_PASSWORD_FAILED] });
        throw error;
    }
}

export async function verifyPasswordResetCode(
    code: string,
    dispatch: Dispatch<Action>,
): Promise<void> {
    try {
        const response = await http.post<PasswordResetVerifyCodeResponse>(
            http.newRequestDescription("/api/password/verify-code"),
            "/api/password/verify-code",
            { code },
        );

        if (response.data.success && response.data.passwordResetFlow) {
            dispatch({ type: Actions[Actions.RESET_PASSWORD_SUCCESS] });
        } else {
            dispatch({ type: Actions[Actions.RESET_PASSWORD_FAILED] });
        }
    } catch (error) {
        dispatch({ type: Actions[Actions.RESET_PASSWORD_FAILED] });
        throw error;
    }
}

export function clearPasswordReset2FA(dispatch: Dispatch<Action>): void {
    dispatch({ type: Actions[Actions.RESET_PASSWORD_CLEAR_2FA] });
}

export function setPassword(
    password: string,
    token: string,
    dispatch: Dispatch<Action>,
): void {
    dispatch({ type: Actions[Actions.SET_PASSWORD_START] });
    http.post(http.newRequestDescription("/api/password/set"), "/api/password/set", {
        password,
        token,
    })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
        .then((responseData: any) => {
            responseData.data.ok
                ? dispatch({ type: Actions[Actions.SET_PASSWORD_SUCCESS] })
                : dispatch({ type: Actions[Actions.SET_PASSWORD_FAILED] });
        })
        .catch(err => {
            dispatch({ type: Actions[Actions.SET_PASSWORD_FAILED] });
        });
}
